export const TOAST_LOADING = 'loading';
export const TOAST_SUCCESS = 'success';
export const TOAST_INFO = 'info';
export const TOAST_ERROR = 'error';
